/*
 * @Author: ningbo.kang
 * @Date: 2019-10-25 16:43:18
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-04-10 17:35:23
 * @FilePath: /fed-authority/src/config/interceptors/router.js
 * @Description: 描述
 */
import NProgress from 'nprogress';
import { goSSO } from '@/utils';
import store from '@/store';
// import auth from '@/utils/auth';
import 'nprogress/nprogress.css'; // progress bar style
import { ignoreRouter } from './whiteList';

NProgress.configure({ showSpinner: false });

export default {};

// const defaultRoutePath = '/dashboard/workplace';

export function routerBeforeEachFunc(to, from, next) {
  NProgress.start(); // start progress bar

  /* 如果页面是从第三方跳入的，验证参数在url参数上，
  首次登陆时可以根据参数删除掉token,但要注意参数在 #中，否则参数有可能一直存在导致无法登录 */
  /* 飞书进入时 先清除token  */
  //  const feishuCode = to.query.code;
  //  if (feishuCode) {
  //    auth.deleteToken()
  //  }

  /* eslint-disable */
  if (store.state.system.app.permission) {
    // 有可能是强制刷新，所以是否登录标志以为是否存在token为依据
    // const token = auth.getToken();
    // 权限与路由校验合并
    // 有登录标记 token，无论是否有效
    // if (token) {
    // 检查是否白名单地址
    if (ignoreRouter(to.path)) {
      next();
    } else if (store.state.system.page.hasCheckPerm) {
      // 检查是否需要已经处理过权限与路由
      // 检查原理见 updateRouter 方法，
      // 检查每个路由配置的 perm 是否在用户权限集合permissionList存在，不存在则认为此路由无效，无权限
      next();
    } else {
      // 清洗无权限路由，清理后，访问无权限会被路由到404页面
      store
        .dispatch("system/page/updateRouter")
        .then(() => {
          const redirect = decodeURIComponent(from.query.redirect || to.path);
          if (to.path === redirect) {
            // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            next({ ...to, replace: true });
          } else {
            // 跳转到目的路由
            next({ path: redirect });
          }
        })
        .catch(() => {
          // 清理路由异常
          goSSO()
        });
    }
  } else {
    next();
  }
  NProgress.done();
  /* eslint-enable */
  //
}

export function routerAfterEachFunc(to) {
  NProgress.done(); // finish progress bar
  // 修正路由meta信息字段 title、tabId
  const {
    name,
    path,
    meta,
    query: { tabTitle = '' },
  } = to;
  const { title, tabId, aliveName } = meta;
  to.meta.title = title || name || '未命名';
  to.meta.tabId = tabId || path;

  try {
    // 匹配组件的名称，用于keepAlive
    to.meta.aliveName = aliveName || to.matched[to.matched.length - 1].components.default.name;
    // console.log('components-name:', to.matched[to.matched.length - 1].components.default.name);
  } catch (error) {
    to.meta.aliveName = '';
  }
  // 如果url上有自定义标题，则覆盖meta上
  if (tabTitle) {
    to.meta.title = tabTitle;
    to.meta.titleKey = '';
  }
  // end
  store.dispatch('system/page/open', to);
  store.commit('system/page/setPageTitle', to.meta.title);
  // 更改标题
  // util.title(to.meta.title);/
}
